import {Typography} from "@mui/material"
import React, {useContext, useMemo} from "react"
import BuildTextWithStyledValues from "./BuildTextWithStyledValues"
import {DataContext} from "../../../../src/context/DataContextProvider"
import {getMerkmal} from "../../../misc/widget-functions"
import _ from "lodash"
import Mustache from "mustache"

export const textTemplaterPrototypes = [
    {
        "key": "color",
        "type": "COLOR",
        "label": "Textfarbe",
        "size": 3,
    },
    {
        "key": "textAlignment",
        "type": "SELECT",
        "label": "Text Positionierung",
        "size": 3,
        "options": [
            {"value": "LEFT", "label": "Links"},
            {"value": "RIGHT", "label": "Rechts"},
            {"value": "CENTER", "label": "Mittig"},
        ],
    },
    {
        "key": "fontWeight",
        "type": "SELECT",
        "label": "Font weight",
        "size": 3,
        "options": [
            {"value": "100", "label": "100"},
            {"value": "200", "label": "200"},
            {"value": "300", "label": "300"},
            {"value": "400", "label": "400"},
            {"value": "500", "label": "500"},
            {"value": "600", "label": "600"},
            {"value": "700", "label": "700"},
            {"value": "800", "label": "800"},
            {"value": "900", "label": "900"},
        ],
    },
    {
        "key": "fontSize",
        "type": "STRING",
        "label": "Text Font Size",
        "size": 3,
    },
    {
        "key": "lineHeight",
        "type": "STRING",
        "label": "Text Line Height",
        "size": 3,
    },
    {
        "key": "simpleTextRender",
        "type": "YESNO",
        "label": "Einfacher Text (ohne extra styling für Werte)",
        "size": 3,
    },
    {
        "key": "valueColor",
        "type": "COLOR",
        "label": "Farbe der Werte",
        "size": 3,
    },
    {
        "key": "valueTextAlignment",
        "type": "SELECT",
        "label": "Positionierung der Werte",
        "size": 3,
        "options": [
            {"value": "LEFT", "label": "Links"},
            {"value": "RIGHT", "label": "Rechts"},
            {"value": "CENTER", "label": "Mittig"},
        ],
    },
    {
        "key": "valueFontWeight",
        "type": "SELECT",
        "label": "Font weight der Werte",
        "size": 3,
        "options": [
            {"value": "100", "label": "100"},
            {"value": "200", "label": "200"},
            {"value": "300", "label": "300"},
            {"value": "400", "label": "400"},
            {"value": "500", "label": "500"},
            {"value": "600", "label": "600"},
            {"value": "700", "label": "700"},
            {"value": "800", "label": "800"},
            {"value": "900", "label": "900"},
        ],
    },
    {
        "key": "valueFontSize",
        "type": "STRING",
        "label": "Font Size der Werte",
        "size": 3,
    },
    {
        "key": "valueLineHeight",
        "type": "STRING",
        "label": "Line Height der Werte",
        "size": 3,
    },
]

const handleMustacheParsing = (text, data) => {
    try {
        return Mustache.render(text, data)
    }
    catch (error) {
        console.error(error)
        return ""
    }
}

const textProps = ["color", "textAlignment", "fontWeight", "fontSize", "lineHeight"]

const collectTextPropsFromWidget = (widget) => _.pick(widget, textProps)

const TextTemplater = ({widget}) => {
    const {getDataFromPointer} = useContext(DataContext)
    const {simpleTextRender, text} = widget
    const textProps = collectTextPropsFromWidget(widget)
    const pointer = getMerkmal(widget)?.pointer
    const data = getDataFromPointer(pointer)

    const renderedText = useMemo(() => handleMustacheParsing(text, data), [data])


    return (
        simpleTextRender ? <Typography {...textProps}>{renderedText}</Typography> :
            <BuildTextWithStyledValues widget={widget} data={data} textProps={textProps} />
    )
}

export default TextTemplater